import loadable from '@loadable/component';

import type { HotelsWithCheapestPriceProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelsWithCheapestPriceProps';

const CardRailWithInventoryCard = loadable(
  () => import('../CardRailWithInventoryCard/CardRailWithInventoryCard'),
);

const HotelsWithCheapestPrice = (props: HotelsWithCheapestPriceProps) => (
  <CardRailWithInventoryCard {...props} />
);

export default HotelsWithCheapestPrice;
